import { render, staticRenderFns } from "./NavFooter.vue?vue&type=template&id=0161620f&scoped=true&"
import script from "./NavFooter.vue?vue&type=script&lang=js&"
export * from "./NavFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavFooter.vue?vue&type=style&index=0&id=0161620f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0161620f",
  null
  
)

export default component.exports